export const getClaimPayload = info => {
  const imageIds = info.images?.map(image => image.id) || []
  const payload = { message: info.message, type: info.type, image_ids: imageIds }

  return payload
}
